export default {
  signInValidations: {
    email: [
      {
        validation: "notEmpty",
        message: "Email is required",
      },
      {
        validation: "email",
        message: "Email is not valid",
      },
    ],
    password: [
      {
        validation: "notEmpty",
        message: "Can't be empty",
      },
      {
        validation: "minLength",
        minLength: 8,
        message: "Minimum 8 characters required",
      },
      {
        validation: "maxLength",
        maxLength: 30,
        message: "Maximum 30 characters",
      },
      {
        validation: "regex",
        regex:
          /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=])(?=\S+$).{8,}$/,
        message:
          "1 upper case & 1 lower case & 1 number & special char required",
      },
    ],
    verificationCode: [
      {
        validation: "notEmpty",
        message: "Verification code is required",
      },
    ],
  },

  signUpValidations: {
    userName: [
      {
        validation: "notEmpty",
        message: "Username is required",
      },
      {
        validation: "minLength",
        minLength: 4,
        message: "Minimum 4 characters required",
      },
      {
        validation: "maxLength",
        maxLength: 30,
        message: "Maximum 30 characters",
      },
      {
        validation: "regex",
        regex: /^[a-z0-9_]*$/,
        message:
          "Only lowercase (a-z), digits (0-9), and underscores are allowed",
      },
    ],
    email: [
      {
        validation: "notEmpty",
        message: "Email is required",
      },
      {
        validation: "email",
        message: "Email is not valid",
      },
    ],
    password: [
      {
        validation: "notEmpty",
        message: "Can't be empty",
      },
      {
        validation: "minLength",
        minLength: 8,
        message: "Minimum 8 characters required",
      },
      {
        validation: "maxLength",
        maxLength: 30,
        message: "Maximum 30 characters",
      },
      {
        validation: "regex",
        regex:
          /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=])(?=\S+$).{8,}$/,
        message:
          "1 upper case & 1 lower case & 1 number & special char required",
      },
    ],
    confirmPassword: [
      {
        validation: "notEmpty",
        message: "Can't be empty",
      },
    ],
    companyName: [
      {
        validation: "notEmpty",
        message: "Company is required",
      },
    ],
    website: [
      {
        validation: "notEmpty",
        message: "Website is required",
      },
    ],
  },

  createPostValidations: {
    description: [
      {
        validation: "notEmpty",
        message: "Description is required",
      },
      {
        validation: "maxLength",
        maxLength: 180,
        message: "Maximum 180 characters",
      },
    ],
  },

  mintPostValidations: {
    name: [
      {
        validation: "notEmpty",
        message: "Name is required",
      },
      {
        validation: "maxLength",
        maxLength: 20,
        message: "Maximum 20 characters",
      },
    ],
    description: [
      {
        validation: "notEmpty",
        message: "Description is required",
      },
    ],
    royalties: [
      {
        validation: "notEmpty",
        message: "Royalties is required",
      },
      {
        validation: "regex",
        regex: /^[0-9]+$/,
        message:
          "Royalties should be in numeric characters without decimal places",
      },
      {
        validation: "range",
        min: 0,
        message: "Royalties shouldn't be less than 0%",
      },
      {
        validation: "range",
        max: 30,
        message: "Royalties should be less than 30%",
      },
    ],
    price: [
      {
        validation: "notEmpty",
        message: "Price is required",
      },
      {
        validation: "lessThan",
        min: 0,
        message: "Price should be more than 0",
      },
      {
        validation: "regex",
        regex: /^[0-9]+(\.[0-9]+)?$/,
        message: "Price should be in numeric characters",
      },
    ],
  },

  editProfileValidations: {
    name: [
      {
        validation: "notEmpty",
        message: "Name is required",
      },

      {
        validation: "maxLength",
        maxLength: 30,
        message: "Maximum 30 character",
      },
    ],
    userName: [
      {
        validation: "notEmpty",
        message: "Username is required",
      },
      {
        validation: "minLength",
        minLength: 4,
        message: "Minimum 4 characters required",
      },
      {
        validation: "maxLength",
        maxLength: 30,
        message: "Maximum 30 character",
      },
      {
        validation: "regex",
        regex: /^[a-z0-9_]*$/,
        message:
          "Only lowercase (a-z), digits (0-9),and underscores and are allowed",
      },
    ],
    bio: [
      {
        validation: "notEmpty",
        message: "Bio is required",
      },
      {
        validation: "maxLength",
        maxLength: 180,
        message: "Maximum 180 character",
      },
    ],
    password: [
      {
        validation: "notEmpty",
        message: "password is required",
      },
      {
        validation: "minLength",
        minLength: 8,
        message: "Minimum 8 characters required",
      },
      {
        validation: "maxLength",
        maxLength: 30,
        message: "Maximum 30 characters",
      },
      {
        validation: "regex",
        regex:
          /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=])(?=\S+$).{8,}$/,
        message:
          "1 upper case & 1 lower case & 1 number & special char required",
      },
    ],
  },

  marketPlaceValidations: {
    bidPrice: [
      {
        validation: "notEmpty",
        message: "Bid price is required",
      },
      {
        validation: "lessThan",
        min: 0,
        message: "Bid price should be more than 0",
      },
    ],
  },
};
